import React from 'react';
import {connect} from 'react-redux';
import lang from '../../constants/Languages.js';
// import {Link} from 'react-router-dom';

import DetailsDescResultsForm from './DetailsDescResultsForm.js';

const DetailsDescResults = ({clang, applyFilter, headingFilters, isLoading, applyFilterRelated}) => {
    const getSelectedFilterOptions = (options) => options.map(option => { return {label: option.label, value: option.id, selected: option.selected}});
    const selectFilter = headingFilters ? headingFilters.filter(filter => filter.type === "SELECT") : false;

    const initialValues = selectFilter ?
                           selectFilter.reduce((obj, item) => {
                             obj[`${item.name}`] = getSelectedFilterOptions(item.options).filter(option => option.selected)[0] || getSelectedFilterOptions(item.options)[0]
                             return obj
                           }, {}) : {};

    const submitForm = (values) => {
        // const newVal = selectOptions.filter(option => option.id === values.headingFiltersSelect.value || option.id === values.headingFiltersSelect.id)[0];
        // applyFilter(newVal);
    };

    const handleChange = (e, name, isRelated) => {
      if ((e.value || e.id) && selectFilter) {
        const newVal = selectFilter.filter(filter => name === filter.name)[0].options.filter(option => option.id === e.value || option.id === e.id)[0];

        if (!isRelated) {
          applyFilter(newVal, name);
        } else {
          applyFilterRelated(newVal, name);
        }
      }
    };

    // const isSelected = (btn) => {
    //     //FAKE SELECTED
    //     // return (btn.options && btn.options.filter(option => option.selected).length > 0) || btn.selected;
    //     return (btn.options && btn.options.filter(option => option.selected).length > 0);
    // };

    return (
        <div className="results__details">
            <h2 className="results__details__header" dangerouslySetInnerHTML={{__html: lang[clang].headings_details.content}}></h2>
            <div className="results__details__heading-filters">
                {selectFilter && !isLoading &&
                  <DetailsDescResultsForm
                    form={`headingFiltersForm`}
                    onSubmit={submitForm}
                    handleChange={handleChange}
                    initialValues={initialValues}
                    getSelectedFilterOptions={getSelectedFilterOptions}
                    filters={selectFilter} />}

            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
});

export default connect(mapStateToProps)(DetailsDescResults);



// WEBPACK FOOTER //
// ./src/components/characteristics-details/DetailsDescResults.js